import {BehaviorSubject, Observable} from 'rxjs';
import {IDefaultService} from '../iDefault.service';
import {AbstractRepositoryV2} from '../../abstractRepositoryV2';
import {AbstractDataServiceAdapter} from '../../dataservice/adapter/abstractDataService.adapter';


export abstract class AbstractFindOneService<StoredEntity, Entity> extends IDefaultService<StoredEntity, Entity> {

    readonly entity$: Observable<Entity> = new BehaviorSubject(null);

    protected id = undefined;
    protected value = undefined;

    protected constructor(repository: AbstractRepositoryV2<StoredEntity>,
                          dataService: AbstractDataServiceAdapter<StoredEntity, Entity, any>) {
        super(repository, dataService);
    }

    public abstract loadEntity(value: any): Promise<Entity>;

    protected setEntity(entity: Entity) {
        (this.entity$ as BehaviorSubject<Entity>).next(entity);
    }

    get entity(): Entity {
        return (this.entity$ as BehaviorSubject<Entity>).value;
    }
}
